import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_25.module.css";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter26.json";
import Common_html from "./Common_html";

function Chapter_26() {
  //     const corosalref = useRef()

  //     useEffect(()=>{
  //       if(corosalref.current)
  //       {
  //           corosalref.current.scrollIntoView({
  //               behavior: "smooth",
  //               block: "nearest",
  //               inline: "start"
  //           })
  //       }
  //       console.log("CurrentImageComponent",corosalref.current);
  //   },[corosalref.current])
  return (
    <>
      <Head>
        <title>WAVEFUNCTION COLLAPSE | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XXV"
        ></meta>
        <meta
          property="og:title"
          content="WAVEFUNCTION COLLAPSE | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration depicting wavefunction collapse within a divine framework, featuring quantum patterns and divine symbols intertwined."></meta>
        <meta
          property="og:description"
          content="Explore the concept of wavefunction collapse within the central doctrine of the Divine Infinite Being, examining how quantum mechanics intersects with divine principles and consciousness."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=26"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration depicting wavefunction collapse within a divine framework, featuring quantum patterns and divine symbols intertwined."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=26"></meta>
        <meta name="twitter:title" content="WAVEFUNCTION COLLAPSE | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the concept of wavefunction collapse within the central doctrine of the Divine Infinite Being, examining how quantum mechanics intersects with divine principles and consciousness."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=26" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}

export default Chapter_26;
